import { ILocationNameSelector } from "../../../store/locationNames/types";
import { apiPrivateAxios } from "../../axios";
import { IGetParams } from "../../types";

export const locationNamesRequest = {
  getLocationNamesSelectors: (
    params?: IGetParams
  ): Promise<ILocationNameSelector[]> =>
    apiPrivateAxios.get("/location/selector", {
      params,
    }),
};

const locationNamesRequestModule = { locationNamesRequest };

export default locationNamesRequestModule;
